import {users as usersShared} from '@cl/shared';
import {KnowledgeRagTopic} from 'common/src/modules/ai/ai.enums';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import campaignSetupContext, {
  placementsSummaryContext,
} from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/campaignSetupAgent.context';
import placementsManagementTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/placementsManagementTool/placementsManagementTool';
import addOrUpdateConditionCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/conditions/addOrUpdateConditionCardTool';
import addOrUpdateContentCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/contentFeeds/addOrUpdateContentCardTool';
import addOrUpdateCreativeCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/creatives/addOrUpdateCreativeCardTool';
import addOrUpdateDistributionCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/distribution/addOrUpdateDistributionCardTool';
import addOrUpdateLocationCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/location/addOrUpdateLocationCardTool';
import addOrUpdateOptimizationCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/optimization/addOrUpdateOptimizationCardTool';
import addOrUpdateProductCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/products/addOrUpdateProductCardTool';
import addOrUpdateScheduleCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/schedule/addOrUpdateScheduleCardTool';
import addOrUpdateSequenceCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/sequence/addOrUpdateSequenceCardTool';
import getSelectionStrategiesTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/strategy/getSelectionStrategiesTool';
import addOrUpdateWeightedCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/weighted/addOrUpdateWeightedCardTool';
import addOrUpdateCompoundConditionCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/compoundConditions/addOrUpdateCompoundConditionCardToolV2';
import addOrUpdateConditionCardToolNG from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/conditions/addOrUpdateConditionCardToolV2';
import addOrUpdateContentCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/content/addOrUpdateContentCardToolV2';
import addOrUpdateCreativeCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/creative/addOrUpdateCreativeCardToolV2';
import {getCardDetailsFromReduxTool} from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/general/getCardDetailsFromReduxTool';
import addOrUpdateLocationCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/location/addOrUpdateLocationCardToolV2';
import addOrUpdateOptimizationCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/optimization/addOrUpdateOptimizationCardToolV2';
import addOrUpdateProductCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/product/addOrUpdateProductCardToolV2';
import addOrUpdateScheduleCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/schedule/addOrUpdateScheduleCardToolV2';
import addOrUpdateWeightedCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/weighted/addOrUpdateWeightedCardToolV2';
import askAboutObjectsTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/askAboutObjectsTool/askAboutObjectsTool';
import autoArrangeCardsTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/autoArrangeCardsTool/autoArrangeCardsTool';
import cardsConnectionTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/cardsConnectionTool/cardsConnectionTool';
import deleteCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/deleteCardTool/deleteCardTool';
import duplicateCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/duplicateCardTool/duplicateCardTool';
import duplicateSubtreeTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/duplicateSubtreeTool/duplicateSubtreeTool';
import readValuesFromExcelTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/readValuesFromExcelTool/readValuesFromExcelTool';
import verifyCampaignPathTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/verifyCampaignPathTool/verifyCampaignPathTool';
import campaignContext from 'common/src/modules/campaigns/copilot/contexts/campaignContext';
import campaignsLibraryContext from 'common/src/modules/campaigns/copilot/contexts/campaignsLibraryContext';
import {CampaignsAgentsToolsNames} from 'common/src/modules/campaigns/copilot/copilotCampaigns.enums';
import createCampaignTool from 'common/src/modules/campaigns/copilot/tools/createCampaignTool';
import duplicateCampaignTool from 'common/src/modules/campaigns/copilot/tools/duplicateCampaignTool';
import getCampaignsMetadataTool from 'common/src/modules/campaigns/copilot/tools/getCampaignsMetadataTool';
import navigateToCampaignVersionTool from 'common/src/modules/campaigns/copilot/tools/navigateToCampaignVersionTool';
import {CampaignStep} from 'common/src/modules/campaignWorkflow/campaignWorkflow.enums';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {doesUserHaveRole} from 'common/src/modules/roles/utils/doesUserHaveRole';
import {EntityTypeToRename} from 'common/src/modules/shared/copilot/copilot.enums';
import analyzeExcelHeadersTool from 'common/src/modules/shared/copilot/tools/analyzeExcelHeadersTool/analyzeExcelHeadersTool';
import batchRenameEntitiesTool from 'common/src/modules/shared/copilot/tools/batchRenameEntitiesTool';
import getFilesTool from 'common/src/modules/shared/copilot/tools/getFilesTool';
import skill from 'common/src/modules/shared/copilot/utils/creators/skill';
import {RoleTypeName} from 'common/src/modules/users/users.types';
import {CLStore} from 'common/src/redux/store';
import {SkillName} from '../../skills.enums';
import campaignSetupSkillInstructions from './campaignSetupSkill.instructions';

function campaignSetupSkill(store: CLStore) {
  const userHasCampaignsWriteRole = doesUserHaveRole(
    usersShared.userSubject.data,
    RoleTypeName.CampaignsWrite,
  );

  const permissionsRelatedTools = userHasCampaignsWriteRole
    ? [
        createCampaignTool({isAllowingSocialCampaigns: true, store}),
        duplicateCampaignTool({store}),
        batchRenameEntitiesTool({
          entityType: EntityTypeToRename.Campaign,
          toolName: CampaignsAgentsToolsNames.BatchRenameCampaigns,
        }),
      ]
    : [];

  const useNewStandaloneAgent = isFlagEnabled(FeatureFlagKey.EnableNewSetupAgentStandaloneAgent);

  const tools = [
    ...permissionsRelatedTools,
    navigateToCampaignVersionTool(store),
    // navigateToCampaignsLibraryTool(store),
    getCampaignsMetadataTool(store),

    ...(useNewStandaloneAgent
      ? [addOrUpdateWeightedCardToolV2(store)]
      : [addOrUpdateWeightedCardTool(store)]),
    addOrUpdateDistributionCardTool(store),
    ...(useNewStandaloneAgent
      ? [addOrUpdateOptimizationCardToolV2(store)]
      : [addOrUpdateOptimizationCardTool(store)]),
    ...(useNewStandaloneAgent
      ? [addOrUpdateCreativeCardToolV2(store)]
      : [addOrUpdateCreativeCardTool(store)]),
    ...(useNewStandaloneAgent
      ? [addOrUpdateScheduleCardToolV2(store)]
      : [addOrUpdateScheduleCardTool(store)]),
    ...(useNewStandaloneAgent
      ? [addOrUpdateConditionCardToolNG(store)]
      : [addOrUpdateConditionCardTool(store)]),
    addOrUpdateCompoundConditionCardToolV2(store),
    addOrUpdateSequenceCardTool(store),
    ...(useNewStandaloneAgent
      ? [addOrUpdateContentCardToolV2(store)]
      : [addOrUpdateContentCardTool(store)]),
    ...(useNewStandaloneAgent
      ? [addOrUpdateLocationCardToolV2(store)]
      : [addOrUpdateLocationCardTool(store)]),
    ...(useNewStandaloneAgent
      ? [addOrUpdateProductCardToolV2(store)]
      : [addOrUpdateProductCardTool(store)]),
    autoArrangeCardsTool(store),
    deleteCardTool(store),
    duplicateSubtreeTool(store),
    duplicateCardTool(store),
    getCardDetailsFromReduxTool(store),
    cardsConnectionTool(store),
    getSelectionStrategiesTool(store),
    askAboutObjectsTool(store),

    getFilesTool(),
    analyzeExcelHeadersTool(),
    readValuesFromExcelTool(),
    verifyCampaignPathTool(CampaignStep.CampaignLogic, store),
    placementsManagementTool(store),
  ];

  return skill({
    name: SkillName.CampaignSetup,
    description:
      'Helps users create, configure, and manage campaign decision trees with cards, logic, and behavior',
    whenToUse:
      'Creating new campaigns, duplicating campaigns, and batch renaming campaigns. Campaign logic and behavior setup including building and editing decision trees with cards. Supports all card types: weighted, optimization, condition, schedule, creative, product, location, content, sequence, and distribution cards. Can add, edit, delete, connect, and duplicate cards, manage fallback creatives, configure placements, and auto-arrange the campaign map. Can also answer questions about existing campaigns and their card configurations using metadata and Excel data.',
    whenToAvoid: 'Campaign analytics, performance metrics, or social campaign configuration.',
    instructions: campaignSetupSkillInstructions,
    tools,
    contextBuilders: [
      campaignContext(store),
      campaignSetupContext(store),
      campaignsLibraryContext(store),
      placementsSummaryContext(store),
    ],
    knowledgeTopics: [KnowledgeRagTopic.CampaignSetupAgent],
    applicableBreadcrumbs: [
      BreadcrumbName.CampaignPage,
      BreadcrumbName.CampaignLogic,
      BreadcrumbName.CampaignsLibrary,
    ],
  });
}

export default campaignSetupSkill;
